<template>
  <div>
    <Breadcrumb :items="breadcrumbs" />
    
    <IpgForm
      v-if="Object.keys(ipgData).length > 0"
      :is-edit-mode="true"
      :initial-data="ipgData"
      :ipg-id="$route.params.id"
      @save="handleSave"
      @cancel="handleCancel"
    />
  </div>
</template>

<script>
import Breadcrumb from "../../../components/breadcrumbs/Breadcrumb.vue";
import IpgForm from "../../../components/forms/IpgForm.vue";
import { IpgService } from "../../../services/IpgService";

export default {
  name: "EditarIpg",
  components: {
    Breadcrumb,
    IpgForm
  },
  data() {
    return {
      breadcrumbs: [
        {
          text: "Página Inicial",
          disabled: false,
          href: "/"
        },
        {
          text: "Gerenciamento de IPGs",
          disabled: false,
          href: "/gerenciar-ipgs"
        },
        {
          text: "Edição da IPG",
          disabled: true,
          href: "/ipgs/editar"
        }
      ],
      ipgData: {},
      loading: false
    };
  },
  async created() {
    await this.carregarIpg();
  },
  methods: {
    async carregarIpg() {
      try {
        this.loading = true;
        const id = this.$route.params.id;
        const response = await IpgService.show(id);
        
        if (response && response.data) {
          this.ipgData = response.data;
        } else {
          console.error('Resposta vazia do serviço');
          throw new Error('IPG não encontrado');
        }
      } catch (error) {
        console.error('Erro ao carregar IPG:', error);
        this.$router.push('/gerenciar-ipgs');
      } finally {
        this.loading = false;
      }
    },
    
    async handleSave(formData) {
      try {
        this.loading = true;
        
        // Criar FormData para atualização
        const postData = new FormData();
        postData.append("_method", "PUT"); // Para método PUT
        postData.append("exercicio", formData.exercicio);
        postData.append("codigo_ipg", formData.codigo_ipg);
        postData.append("descricao", formData.descricao);
        postData.append("ativo", formData.ativo ? 1 : 0);
        
        const id = this.$route.params.id;
        const response = await IpgService.update(id, postData);
        
        if (response) {
          this.$router.push('/gerenciar-ipgs');
        } else {
          throw new Error('Erro ao atualizar IPG');
        }
      } catch (error) {
        console.error('Erro ao atualizar IPG:', error);
        this.$globalAlert('Erro ao atualizar IPG', 'error');
      } finally {
        this.loading = false;
      }
    },
    
    handleCancel() {
      // Retornar para a tela de listagem dos IPGs
      this.$router.push('/gerenciar-ipgs');
    }
  }
};
</script>

<style scoped>
/* Estilos específicos da página, se necessário */
</style>